// Shared presentational primitives (Task 13.7).
//
// Card containers (rounded corners, Req 28.6) and stat tiles reused across the
// dashboards, profile, and admin panel. Buttons rely on the global `.sb-btn`
// styles which guarantee the >=44px touch target (Req 29.7).

import type { ReactNode } from "react";
import { badgeName } from "../lib/badgeDisplay";
import type { BadgeId } from "@sharebite/domain";

export function Card({
  title,
  children,
  action,
}: {
  title?: string;
  children: ReactNode;
  action?: ReactNode;
}): JSX.Element {
  return (
    <section className="sb-card">
      {(title || action) && (
        <div className="sb-row">
          {title && <h2 className="sb-card__title">{title}</h2>}
          <span className="sb-spacer" />
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Stat({
  label,
  value,
}: {
  label: string;
  value: number | string;
}): JSX.Element {
  return (
    <div className="sb-stat">
      <div className="sb-stat__value">{value}</div>
      <div className="sb-stat__label">{label}</div>
    </div>
  );
}

export function BadgeList({ badges }: { badges: BadgeId[] }): JSX.Element {
  if (badges.length === 0) {
    return <p className="sb-muted">No badges earned yet.</p>;
  }
  return (
    <div>
      {badges.map((b) => (
        <span key={b} className="sb-badge">
          {badgeName(b)}
        </span>
      ))}
    </div>
  );
}
